export enum Billing {
	PerUnit,
	Periodically,
}

export enum Status {
	WaitingRespose = 'WaitingRespose',
	Accepted = 'Accepted',
	Denied = 'Denied',
}

export enum State {
	Received = 'Received',
	ResearchInProgress = 'ResearchInProgress',
	ResearchCompleted = 'ResearchCompleted',
	Delivered = 'Delivered',
	// Temporary orderstate until backend is updated.
	WaitingForConsent = 'WaitingForConsent',
	ConsentWithdrawn = 'ConsentWithdrawn',
	ConsentDeclined = 'ConsentDeclined',
	Deleted = 'Deleted',
	ConsentGiven = 'ConsentGiven',
	WaitingForResearcher = 'WaitingForResearcher',
	// ApprovalGiven = 'ApprovalGiven',
	// ApprovalWithdrawn = 'ApprovalWithdrawn',
	// 	WaitingForApproval = 'WaitingForApproval',
	// ApprovalDeclined = 'ApprovalDeclined',
	// Deleted = 'Deleted',
}

export enum LoginType {
	None = 'None',
	BankId = 'BankId',
	VerificationCode = 'VerificationCode',
}

export const LoginTypes = [
	LoginType.BankId,
	LoginType.VerificationCode,
]

export enum ApprovalState {
	Signature = 'Signature',
	LegitimateInterestAssessment = 'LegitimateInterestAssessment',
	InsuranceDistributionDirective = 'InsuranceDistributionDirective'
}

export type Language = "Svenska" | "English"
